/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/require-default-props */
import React, { FC } from 'react'
import { Checkbox } from 'antd'
import cn from 'classnames'
import { OrderedListItemModel } from 'Models'
import { BtnComponent, UISizes, TextType, Text } from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'

interface GridRowProps {
	item: any
	columns: OrderedListItemModel[]
	checkable?: boolean
	gridCheckable?: boolean
	expandable?: boolean
	isChecked?: boolean
	onCheck?: (ids: number[], checked: boolean) => void
	opened: number
	setOpen: (id: number) => void
	action?: Callback | null
	actionTitleCode?: string
	OpenedComponent?: any
	CustomColumnsComponent?: any
	customActions?: { [key: string]: Callback }
	actionRow?: (item: any) => void
	isSelected: boolean
	disableCheck?: boolean
}
export const getWidthValue = (value): { width: number } | { minWidth: string } =>
	Number.isInteger(value) ? { minWidth: `${value}px` } : { width: value }

export const GridRowComponent: FC<GridRowProps> = ({
	item,
	columns,
	checkable = false,
	isChecked = false,
	opened,
	action,
	setOpen,
	actionTitleCode,
	OpenedComponent,
	CustomColumnsComponent,
	customActions,
	onCheck,
	expandable = false,
	gridCheckable = false,
	actionRow,
	isSelected,
	disableCheck,
}) => {
	const isOpen = item.id === opened
	const inActive = opened && !isOpen
	const toggleOpened = (): void => setOpen(!isOpen ? item.id : null)

	const checkAll = (e): void => {
		const { checked } = e.target
		if (!onCheck) return
		onCheck([item.id], checked)
	}

	const getControl = (): JSX.Element => (
		<span className="ppneo-grid-row__control">
			<BtnComponent
				icon={isOpen ? 'chevron-up' : 'chevron-down'}
				size={UISizes.SMALL}
				link
				onClick={toggleOpened}
			/>
		</span>
	)

	const getCheckBox = (): JSX.Element => {
		if (checkable) {
			return <Checkbox onChange={checkAll} checked={isChecked} disabled={disableCheck} />
		}
		return null
	}

	const getCell = (column): JSX.Element =>
		column.custom ? (
			<CustomColumnsComponent slug={column.slug} item={item} customActions={customActions} />
		) : (
			<Text type={TextType.CAPTION} colorIndex={8}>
				{item[column.slug]}
			</Text>
		)

	const actionHandler = (): void => {
		if (action) action()
	}

	// const rowActionHandler = (): void => actionRow && actionRow(item)

	const listClass = cn('ppneo-grid-row__list', {
		[`ppneo-grid-row__list--checkable`]: checkable,
		[`ppneo-grid-row__list--grid-checkable`]: !checkable && gridCheckable,
	})

	const rowClass = cn('ppneo-grid-row', {
		[`ppneo-grid-row--inactive`]: inActive,
		[`ppneo-grid-row--action`]: actionRow,
		[`ppneo-grid-row--select`]: isSelected,
		[`ppneo-grid-row--colored`]: opened === item.id,
	})
	return (
		<div className="ppneo-grid-row__container">
			<div className="ppneo-collapse">
				{isOpen && OpenedComponent ? (
					<div className={`${rowClass} ppneo-grid-row--opened`}>
						{getCheckBox()}
						<OpenedComponent
							item={item}
							action={action}
							columns={columns}
							opened={opened}
							setOpen={setOpen}
							getCell={getCell}
						/>
						{getControl()}
					</div>
				) : (
					<div className={rowClass}>
						<div className="ppneo-grid-row__line">
							{getCheckBox()}
							<ul className={listClass}>
								{columns.map(
									(column: OrderedListItemModel): JSX.Element => (
										// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
										<li
											className="ppneo-grid-row__item"
											key={column.slug}
											style={getWidthValue(column.width)}
											// onClick={rowActionHandler}
										>
											{getCell(column)}
										</li>
									)
								)}
							</ul>
							{action && !actionRow && (
								<div className="ppneo-grid-row__buttons">
									<BtnComponent
										size={UISizes.SMALL}
										title={actionTitleCode || ''}
										outline
										onClick={actionHandler}
									/>
								</div>
							)}
							{expandable && getControl()}
						</div>
					</div>
				)}
			</div>
		</div>
	)
}
